import s from"./classes/URLSearchParams.js";import a from"./classes/FormData.js";import r from"./classes/Blob.js";var o={isBrowser:!0,classes:{URLSearchParams:s,FormData:a,Blob:r},protocols:["http","https","file","blob","url","data"]};export{o as default};
//# sourceMappingURL=index.js.map
